import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import * as compose from 'lodash.flowright';
import { withTranslation } from 'react-i18next';
import { UserByInvitationCode } from 'graphqlDocuments/queries';
import setAndroidReferrer from 'utils/setAndroidReferrer';
import getValidatedParams from 'utils/getValidatedParams';
import { codeOrUsername } from 'utils/schemaUtils';

export const extractCode = (match) => {
  const { params } = match;
  const { code } = getValidatedParams({
    params,
    schema: { code: codeOrUsername },
  });
  return code;
};

function withApolloCompat(WrappedComponent) {
  return function WithApolloCompatWrapper(props) {
    const { match } = props;
    const code = extractCode(match);
    useEffect(() => {
      if (code) {
        setAndroidReferrer('referralCode', code);
      }
    }, [code]);

    const query = useQuery(UserByInvitationCode, {
      variables: { code },
      skip: !code,
    });
    const { data, loading } = query;

    return (
      <WrappedComponent
        {...props}
        loading={loading}
        referrerEmail={data?.user?.email || null}
        matchingPeer={{
          id: data?.user?.id,
          name: data?.user?.username,
        }}
      />
    );
  };
}

const InvitationContainer = (Invitation) =>
  compose(withTranslation('REFERRALS'), withApolloCompat)(Invitation);

export default InvitationContainer;
